// CMMS UI role gates — mirror backend policies in OEE.Web/Program.cs.
// Role ids: Admin=1, Superuser=2, Operator=3, Technician=4.
//
// Technician is a role of its own, not an alias for Operator(3). Treating them as the same
// identity is what made "operators must not close jobs" impossible to enforce.

// Cmms_Field policy = RoleRequirement(4,3,2,1): report a problem, create a work order,
// comment, asset documents. The operator's world, plus Superuser.
//
// It administers the tool register at /tools (route gate
// anyOf={[1,2]}), whose service status column reads api/tool-monitoring/status. Keep this in
// step with Program.cs — a constant that is narrower than the policy hides actions the
// backend would allow, and one that is wider offers actions that 403.
export const CMMS_FIELD_ROLES = [1, 2, 3, 4];

// Cmms_Technician policy = RoleRequirement(4,1): claim, check in/out, materials, actual
// asset, the -> InProgress / -> Completed transitions, and Completed -> Closed. Performing
// the work, as opposed to reporting it — including signing off the job you just finished,
// which is what writes the ToolServiceLog that resets the tool's interval.
export const CMMS_TECHNICIAN_ROLES = [1, 4];

// Cmms_Manager / Role_Admin: edit WO, escalate, reopen, delete, asset mutations, and the
// force-close edge (Open -> Closed) that reaches Closed without the work being done.
// It also carries the recurring schedules page's write side: create, edit, delete and the
// active toggle, alongside the counter reset that was already here. A schedule raises work
// orders unattended, so changing one changes what the module does with nobody watching.
// (A CMMS_RECURRING_ROLES = [1, 2] constant used to sit here unused, proposing Superuser as
// a schedule planner. That question was answered against it when the page was gated, and the
// constant went with the answer — a second, contradictory schedule constant is how the next
// control gets gated wrongly.)
export const CMMS_MANAGER_ROLES = [1];
